import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { usercreds } from '../../models/interfaces/usercreds';
import { NavController, LoadingController } from 'ionic-angular';
import { ToastProvider } from '../toast/toast';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthProvider {

  constructor(private loadingCtrl: LoadingController, private toast: ToastProvider, public afireauth: AngularFireAuth) {

  }

  login(credentials: usercreds) {
    const loading = this.loadingCtrl.create({
      spinner: 'crescent',
      content: 'Logging In...',
    });
    loading.present();
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.signInWithEmailAndPassword(credentials.email, credentials.password).then(() => {
        loading.dismiss();
        resolve(true);
      }).catch((err) => {
        reject(err);
        loading.dismiss();
        if (err.message == "A network error (such as timeout, interrupted connection or unreachable host) has occurred.")
          this.toast.show("No internet connection!");
        else if (err.message == "The email address is badly formatted.")
          this.toast.show("Invalid email address!");
        else
          this.toast.show(err.message);
      })
    })
    return promise;

  }

}


// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts